import * as React from 'react';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';

export default function ReactDatePicker(props: ReactDatePickerProps) {
  return <DatePicker locale="nb" {...props} />;
}
